
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  get (data) {
    // limit
    const active = data.active ? '&active=' + data.active : '&active=' + 0
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // search
    const search = data.search ? '&s=' + data.search + '&s_field=name,email,address_country,address_line_1,address_line_2,address_city,address_postcode,address_state,region,student_name' : ''
    // pagination
    const page = data.page ? '&page=' + data.page : ''
    return axios.get(process.env.API_ENDPOINT + '/client?token=' + VueCookies.get('token') + page + search + limit + active)
  },
  create (data) {
    return axios.post(process.env.API_ENDPOINT + '/client?token=' + VueCookies.get('token'), data)
  },
  show (id) {
    return axios.get(process.env.API_ENDPOINT + '/client/' + id + '?token=' + VueCookies.get('token'))
  },
  update (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/client/' + id + '?token=' + VueCookies.get('token'), data)
  },
  delete (id) {
    return axios.delete(process.env.API_ENDPOINT + '/client/' + id + '?token=' + VueCookies.get('token'))
  },
  deactivate (data) {
    return axios.post(process.env.API_ENDPOINT + '/client/change-status/' + data.id + '?token=' + VueCookies.get('token'), data)
  }
}



// WEBPACK FOOTER //
// ./src/store/api/clients.js